export default function formatUrlQuery (query) {
	let searchQuery = '';

	if (typeof query === 'object') {
		searchQuery = (function () {
			let params = Object.keys(query);
			let i = -1;
			let param;
			let search = [];

			while (++i in params) {
				param = params[i];
				search.push(`${param}=${query[param]}`);
			}
			return search.length ? (`?${encodeURI(search.join('&'))}`) : '';
		}());
	}

	return searchQuery;
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/format-url-query.js
// module id = null
// module chunks = 